// extracted by mini-css-extract-plugin
export default {"button":"_1YVk9OQPdbU0VbptS3vn4a"};